import React, { useState, useEffect, useRef } from 'react'
import { Table } from "antd";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import Beatloader from '../../../../../../../Common/Loaders/Beatloader';
// import { getFFSeaImportConsoleManifestList, getFFSeaImportConsoleManifestMBLAddList } from '../../../../../../../Redux/action/FreightForwarding/Console/FFSeaImpAction';
import { convertYYYY_MM_DDtoDD_MMM_YYYYformat } from '../../../../../../../HelperFunctions';
import AddFFSeaImpConsoleManifest from './AddFFSeaImpConsoleManifest';
import axios from 'axios';
import { adminMainUrl } from '../../../../../../../Config';
import { useFormik } from 'formik';
import Select from 'react-select';
import { getHrmsBranchList } from '../../../../../../../Redux/action/Organisation/Branch/BranchAction';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import OverlayLoader from '../../../../../../../Common/Loaders/OverlayLoader';
import { getFFSeaImportConsoleManifestList, getFFSeaImportConsoleManifestMBLAddList } from '../../../../../../../Redux/action/FreightForwarding/Sea/FFSeaImpAction';
import Tabbings from '../../../Tabs/Tabbings';


const renderTooltipCell = (text, maxLength = 20, tooltipId = 'cell-tt') => {
    if (!text || text === '-' || text === '') return '-';
    const strText = String(text);
    if (strText.length > maxLength) {
        return (
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={tooltipId}>{strText}</Tooltip>}
            >
                <span className="cursor-pointer text-truncate d-inline-block" style={{ maxWidth: '160px', verticalAlign: 'middle' }}>
                    {strText}
                </span>
            </OverlayTrigger>
        );
    }
    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={tooltipId}>{strText}</Tooltip>}
        >
            <span>{strText}</span>
        </OverlayTrigger>
    );
};

const ListFFSIConsoleManifest = ({ accessedModules, accessedPermission, title, console_manifest_url, console_master_url, console_house_url, direct_master_url, job_order_url, tab_imp_exp, tab_air_sea }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [showLoader, setShowLoader] = useState(false);
    const [dataSource, setDataSource] = useState([]);

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    //pagination 
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const queryParams = new URLSearchParams(location.search);

    let { HrmsBranchList } = useSelector(state => state?.BranchReducer || {});
    const filterBranchList = HrmsBranchList && Array.isArray(HrmsBranchList) ? HrmsBranchList.map((item) => ({
        value: item.branch_id,
        label: item.branch_name,
    })) : [];

    let { sidebarPermissionHRMSData } = useSelector(state => state?.NavbarReducer || {});
    const hasFilterPermission = sidebarPermissionHRMSData?.role_id == sidebarPermissionHRMSData?.user_id;

    useEffect(() => {
        if (token && user_id) {
            dispatch(getHrmsBranchList(token, user_id));
        }
    }, [token, user_id]);

    const formik = useFormik({
        initialValues: {
            search_text: queryParams.get("search_text") || "",
            branch_id: queryParams.get("branch_id") || "",
        },
        onSubmit: (values) => {
            const params = new URLSearchParams();
            Object.keys(values).forEach(key => {
                if (values[key]) {
                    params.append(key, values[key]);
                }
            });
            params.set("page", "1");
            navigate(`?${params.toString()}`);
        },
    });

    const resetFilters = () => {
        formik.resetForm();
        navigate(location.pathname);
    };

    useEffect(() => {
        if (token && user_id) {
            const queryParamsObj = new URLSearchParams(location.search);
            queryParamsObj.delete("page");
            const filterQueryString = queryParamsObj.toString();
            dispatch(getFFSeaImportConsoleManifestList(token, user_id, queryParams.get("page") ?? 1, filterQueryString));
            dispatch(getFFSeaImportConsoleManifestMBLAddList(token, user_id));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, location.pathname, location.search]);

    const refresh = () => {
        if (token && user_id) {
            dispatch(getFFSeaImportConsoleManifestList(token, user_id, queryParams.get("page") ?? 1));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }

    const {
        loadingFFSeaImpConsoleManifestList,
        FFSeaImpConsoleManifestList,
        FFSeaImpConsoleManifestListError,
        FFSeaImpConsoleManifestListCurrentPage,
        FFSeaImpConsoleManifestListTotalPage,
        FFSeaImpConsoleManifestListTotalData,

        loadingFFSeaImpUnusedConsoleManifestMBLAddList,
        FFSeaImpUnusedConsoleManifestMBLAddList,
        FFSeaImpUnusedConsoleManifestMBLAddListError,
    } = useSelector(state => state?.FFSeaImpReducer);

    const [addMBLListOptions, setAddMBLList] = useState([]);
    useEffect(() => {
        if (FFSeaImpUnusedConsoleManifestMBLAddList) {
            let arr = [];
            FFSeaImpUnusedConsoleManifestMBLAddList.map((val) => arr.push({ value: val.id, label: val.mbl_number }));
            setAddMBLList(arr);
        }
    }, [FFSeaImpUnusedConsoleManifestMBLAddList])


    useEffect(() => {
        if (loadingFFSeaImpConsoleManifestList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
    }, [loadingFFSeaImpConsoleManifestList]);

    const [disableDownloadPDF, setDisableDownloadPDF] = useState(false);

    const downloadManifest = (id) => {
        if (!id) { toast.error("Console Manifest not found"); return; }
        setDisableDownloadPDF(true);
        let config = { headers: { 'auth-token': token, user_id: user_id }, responseType: 'blob', };
        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/sea/import/console-manifest/pdf-generation?id=${id}`, config)
                .then(response => {
                    if (response.status == 200) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `CONSOLE_MANIFEST_${id}.pdf`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadPDF(false);
                    } else {
                        toast.error(response.error.message);
                        setDisableDownloadPDF(false);
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error(error.message);
                    setDisableDownloadPDF(false);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
            setDisableDownloadPDF(false);
        }
    }

    const downloadAll = (id) => {
        if (!id) { toast.error("Console Manifest not found"); return; }
        // console.log("hi hello")
        setDisableDownloadPDF(true);
        let config = { headers: { 'auth-token': token, user_id: user_id }, responseType: 'blob', };
        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/air/export/console-manifest/all-pdf-generation?id=${id}`, config)
                .then(response => {
                    if (response.status == 200) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `ALL_CONSOLE_MANIFEST.pdf`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadPDF(false);
                    } else {
                        toast.error(response.error.message);
                        setDisableDownloadPDF(false);
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error(error.message);
                    setDisableDownloadPDF(false);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
            setDisableDownloadPDF(false);
        }
    }


    useEffect(() => {
        if (FFSeaImpConsoleManifestList) {
            let arr = [];
            FFSeaImpConsoleManifestList.map((val, index) => {
                let obj = {
                    sno: index + 1,
                    console_manifest_number: renderTooltipCell(val.console_manifest_unique_id, 18, `tt-cm-${index}`),
                    generated_date: val.generated_date ? convertYYYY_MM_DDtoDD_MMM_YYYYformat(val.generated_date) : "-",
                    mbl_number: renderTooltipCell(val?.si_console_manifest_mbl_detail ? val?.si_console_manifest_mbl_detail?.mbl_number : "-", 18, `tt-mbl-${index}`),
                    action: (
                        <div className="dropdown table-action">
                            <OverlayTrigger placement="top" overlay={<Tooltip id={`tt-act-${index}`}>Actions</Tooltip>}>
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                            </OverlayTrigger>
                            <div className="dropdown-menu dropdown-menu-right">
                                {accessedPermission.includes("ff_se_console_manifest_download") && <button className="dropdown-item" onClick={() => { downloadManifest(val.id) }} disabled={disableDownloadPDF} >
                                    {disableDownloadPDF ? <><i className="fas fa-spinner fa-spin me-1"></i> Downloading...</> : <><i className="fa-solid fa-download text-blue-light me-1"></i> Download Console Manifest</>}
                                </button>}
                                {/* {accessedPermission.includes("ff_se_console_manifest_download") && <button className="dropdown-item" onClick={() => { downloadAll(val.id) }} disabled={disableDownloadPDF} >
                                    {disableDownloadPDF ? <><i className="fas fa-spinner fa-spin me-1"></i> Downloading...</> : <><i className="fa-solid fa-download text-blue-light me-1"></i> Download Related MAWB & HAWBs</>}
                                </button>} */}

                            </div>
                        </div>
                    ),
                };
                arr.push(obj);
            });
            setDataSource(arr);
        }
    }, [FFSeaImpConsoleManifestList]);

    useEffect(() => {
        if (FFSeaImpConsoleManifestListCurrentPage) {
            setCurrentPage(FFSeaImpConsoleManifestListCurrentPage);
        }

        if (FFSeaImpConsoleManifestListTotalPage) {
            setTotalPages(FFSeaImpConsoleManifestListTotalPage)
        }
    }, [
        FFSeaImpConsoleManifestListCurrentPage,
        FFSeaImpConsoleManifestListTotalPage,
        FFSeaImpConsoleManifestListTotalData
    ]);

    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };

    // adjust the add and update forms
    const [showAdd, setShowAdd] = useState(false);
    const handleAddClose = () => setShowAdd(false);
    const handleAddShow = () => setShowAdd(true);

    const [showEdit, setShowEdit] = useState(false);
    const handleEditClose = () => setShowEdit(false);
    const handleEditShow = () => setShowEdit(true);

    const columns = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "Console Manifest No.", dataIndex: "console_manifest_number", key: "console_manifest_number" },
        { title: "Generated Date", dataIndex: "generated_date", key: "generated_date" },
        { title: "MBL No.", dataIndex: "mbl_number", key: "mbl_number" },
        // { title: "HAWB Numbers", dataIndex: "hawb_numbers", key: "hawb_numbers" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];


    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <div className="page-wrapper">
                        <div className="content">
                            <div className="row">
                                <div className="col-md-12">
                                    {/* Page Header */}
                                    <div className="page-header">
                                        <div className="row align-items-center">
                                            <div className="col-8">
                                                <h4 className="page-title">
                                                    {title} <span className="count-title">{FFSeaImpConsoleManifestListTotalData ? FFSeaImpConsoleManifestListTotalData : "0"}</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                    {/* /Page Header */}
                                </div>
                            </div>
                            <Tabbings
                                console_manifest_url={console_manifest_url}
                                console_master_url={console_master_url}
                                console_house_url={console_house_url}
                                direct_master_url={direct_master_url}
                                job_order_url={job_order_url}
                                tab_imp_exp={tab_imp_exp}
                                tab_air_sea={tab_air_sea}
                                accessedPermission={accessedPermission}
                            />
                            <div className="card">
                                <div className="card-header">
                                    {accessedPermission.includes("ff_ae_console_manifest_add") && <div className="d-flex justify-content-end">
                                        {/* <Link to="/flexichain/job-order/freight-forwarding/shipment/air/export/console/manifest/add" className="btn btn-sm btn-primary">+Add Console Manifest</Link> */}
                                        <button className="btn btn-sm btn-primary" onClick={handleAddShow}>+Add Console Manifest</button>
                                    </div>}
                                </div>
                                <div className="card-body">
                                    {/* Filter Form */}
                                    <form onSubmit={formik.handleSubmit}>
                                        <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-3">
                                            <div className="d-flex align-items-center flex-wrap row-gap-2">
                                                <div className="icon-form mb-3 mb-sm-0 mx-1">
                                                    <span className="form-icon">
                                                        <i className="ti ti-search" />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Search..."
                                                        name='search_text'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.search_text}
                                                    />
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center flex-wrap row-gap-2">
                                                {hasFilterPermission && (
                                                    <div className="form-sorts dropdown me-2">
                                                        <a href="javascript:void(0);" data-bs-toggle="dropdown" data-bs-auto-close="outside">
                                                            <i className="ti ti-filter-share" /> Filter
                                                        </a>
                                                        <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                                                            <div className="filter-set-view">
                                                                <div className="filter-set-head">
                                                                    <h4><i className="ti ti-filter-share" /> Filter</h4>
                                                                </div>
                                                                <table className="content-table">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td><label>BRANCH</label></td>
                                                                            <td className="input_box_filter">
                                                                                <Select
                                                                                    className="ms-2"
                                                                                    classNamePrefix="react-select"
                                                                                    placeholder="Select Branch"
                                                                                    options={filterBranchList}
                                                                                    isClearable
                                                                                    styles={{
                                                                                        container: (base) => ({ ...base, width: '100%', minWidth: '220px' }),
                                                                                        control: (base) => ({ ...base, minHeight: '33px', height: '32px', fontSize: '12px' }),
                                                                                        valueContainer: (base) => ({ ...base, height: '32px', padding: '0 6px' }),
                                                                                        indicatorsContainer: (base) => ({ ...base, height: '32px' }),
                                                                                        menu: (base) => ({ ...base, fontSize: '12px' }),
                                                                                        option: (base) => ({ ...base, fontSize: '12px', padding: '4px 8px' }),
                                                                                    }}
                                                                                    value={filterBranchList.find(opt => opt.value == formik.values.branch_id) || null}
                                                                                    onChange={(selected) => formik.setFieldValue("branch_id", selected ? selected.value : "")}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <div className="filter-reset-btns">
                                                                    <div className="row">
                                                                        <div className="col-6">
                                                                            <a href="javascript:void(0);" className="btn btn-light w-100" onClick={resetFilters}>Reset</a>
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <button type="submit" className="btn btn-primary w-100">Filter</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </form>

                                    {/* Contact List */}
                                    <div className="table-responsive custom-table">
                                        <Table className="table datanew dataTable no-footer"
                                            // rowSelection={rowSelection} 
                                            dataSource={dataSource}
                                            columns={columns}
                                            pagination={false} />
                                    </div>

                                    <div className="row align-items-center">
                                        {dataSource.length ? <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                            <ReactPaginate
                                                previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                nextLabel={<img src="/img/left.png" alt="Next" />}
                                                breakLabel="..."
                                                breakClassName="break-me"
                                                pageCount={totalPages}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={5}
                                                onPageChange={handlePageClick}
                                                containerClassName="pagination"
                                                activeClassName="active"
                                                forcePage={currentPage - 1}
                                            />
                                        </div> :
                                            null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }

            <AddFFSeaImpConsoleManifest
                show={showAdd}
                handleClose={handleAddClose}
                loadingFFSeaImpUnusedConsoleManifestMBLAddList={loadingFFSeaImpUnusedConsoleManifestMBLAddList}
                addMBLListOptions={addMBLListOptions}
                token={token}
                user_id={user_id}
                refresh={refresh}
            />

            {
                disableDownloadPDF && <OverlayLoader />
            }

        </>

    )
}

export default ListFFSIConsoleManifest